export interface IProducts {
  pafRetail: number;
  vscRetail: number;
  gapRetail: number;
  comRetail: number;
  vrpRetail: number;
}

export class ProductsModel implements Partial<IProducts> {
  pafRetail?: number;
  vscRetail?: number;
  gapRetail?: number;
  comRetail?: number;
  vrpRetail?: number;

  constructor(data?: Partial<IProducts>) {
    if (data) {
      this.pafRetail = data.pafRetail;
      this.vscRetail = data.vscRetail;
      this.gapRetail = data.gapRetail;
      this.comRetail = data.comRetail;
      this.vrpRetail = data.vrpRetail;
    }
  }
}
